<template>
  <ValidationProvider tag="tr" :vid="vid" :mode="veeMode" :rules="veeRules" v-slot="{ invalid, errors }">
    <th scope="row" width="25%">{{ label }}</th>
    <td width="10%">
      <span class="bg-red" v-show="isRequired">必須</span>
    </td>
    <td class="form-inline no-margin-top flex">
      <template v-if="options.length > 0">
        <div v-for="(option, index) in options" :key="index" :value="option.code" :name="option.name">
          <div>
            <label>
              <input
                type="checkbox"
                :value="option.code"
                v-model="selectedValue"
                style="margin-right: 5px;"
                :disabled="disableMaterialCheck(option.code) || disableBoxes"
                @change="checkMaterial(option.code)"
              />
              <span :class="{ disabledText: disableMaterialCheck(option.code) }">
                {{ option.name }}
              </span>
            </label>
          </div>
        </div></template
      >
      <template v-else>ー</template>
      <slot name="afterInput" :invalid="invalid" :errors="errors" />
      <slot name="feedback" :invalid="invalid" :errors="errors">
        <div class="invalid-feedback" v-show="invalid">{{ errors[0] }}</div>
      </slot>
    </td>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import uniq from 'lodash/uniq';
import sortBy from 'lodash/sortBy';

export default {
  inheritAttrs: false,
  data() {
    return {
      disableCodeList: [],
      //
      disableListOfCode100: ['400', '500', '600', '700'],
      disableListOfCode200: ['300', '500', '600', '700'],
      disableListOfCode300: ['200', '500', '600', '700'],
      disableListOfCode400: ['100', '500', '600', '700'],
      disableListOfCode500: ['100', '200', '300', '400', '600', '700'],
      disableListOfCode600: ['100', '200', '300', '400', '500', '700'],
      disableListOfCode700: ['100', '200', '300', '400', '500', '600'],
    };
  },
  props: {
    disableBoxes: {
      type: Boolean,
      default: false,
    },
    vid: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [], // Ex: [{value: 1, text: 'abc'}, {value: 2, text: 'bcd'}]
    },
    optionLabel: {
      type: String,
      default: 'text',
    },
    optionValue: {
      type: String,
      default: 'value',
    },
    value: {
      type: Array,
      default: () => [],
    },
    checkedLists: {
      type: Array,
      default: () => [],
    },
    inputClass: {
      type: String,
      default: 'col-lg-6',
    },
    extraRules: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    baseRule: {
      type: String,
      default: '',
    },
  },
  components: {
    ValidationProvider,
  },
  methods: {
    buildClasses(veeClasses) {
      let veeClassesActive = Object.keys(veeClasses).filter((key) => veeClasses[key]);

      // Only add class is-valid or is-invalid for no required field when input has value
      veeClassesActive = this.isRequired || (this.value && veeClasses.validated) ? veeClassesActive : {};

      return ['form-control', 'no-padding', this.inputClass].concat(Object.values(veeClassesActive)).join(' ');
    },
    checkMaterial(materialCode) {
      switch (materialCode) {
        case '400':
          if (!this.selectedValue.includes('400')) {
            this.disableCodeList = [...this.disableCodeList, ...this.disableListOfCode400];
          } else {
            const removeCodeList = [...this.disableListOfCode400];
            for (const code of removeCodeList) {
              this.disableCodeList.splice(this.disableCodeList.indexOf(code), 1);
            }
          }
          break;
        case '100':
          if (!this.selectedValue.includes('100')) {
            this.disableCodeList = [...this.disableCodeList, ...this.disableListOfCode100];
          } else {
            const removeCodeList = [...this.disableListOfCode100];
            for (const code of removeCodeList) {
              this.disableCodeList.splice(this.disableCodeList.indexOf(code), 1);
            }
          }
          break;
        case '200':
          if (!this.selectedValue.includes('200')) {
            this.disableCodeList = [...this.disableCodeList, ...this.disableListOfCode200];
          } else {
            const removeCodeList = [...this.disableListOfCode200];
            for (const code of removeCodeList) {
              this.disableCodeList.splice(this.disableCodeList.indexOf(code), 1);
            }
          }
          break;
        case '300':
          if (!this.selectedValue.includes('300')) {
            this.disableCodeList = [...this.disableCodeList, ...this.disableListOfCode300];
          } else {
            const removeCodeList = [...this.disableListOfCode300];
            for (const code of removeCodeList) {
              this.disableCodeList.splice(this.disableCodeList.indexOf(code), 1);
            }
          }
          break;
        case '700':
          if (!this.selectedValue.includes('700')) {
            this.disableCodeList = [...this.disableCodeList, ...this.disableListOfCode700];
          } else {
            const removeCodeList = [...this.disableListOfCode700];
            for (const code of removeCodeList) {
              this.disableCodeList.splice(this.disableCodeList.indexOf(code), 1);
            }
          }
          break;
        case '600':
          if (!this.selectedValue.includes('600')) {
            this.disableCodeList = [...this.disableCodeList, ...this.disableListOfCode600];
          } else {
            const removeCodeList = [...this.disableListOfCode600];
            for (const code of removeCodeList) {
              this.disableCodeList.splice(this.disableCodeList.indexOf(code), 1);
            }
          }
          break;
        case '500':
          if (!this.selectedValue.includes('500')) {
            this.disableCodeList = [...this.disableCodeList, ...this.disableListOfCode500];
          } else {
            const removeCodeList = [...this.disableListOfCode500];
            for (const code of removeCodeList) {
              this.disableCodeList.splice(this.disableCodeList.indexOf(code), 1);
            }
          }
          break;
      }
    },
    disableMaterialCheck(materialCode) {
      for (const code of this.disableCodeList) {
        if (materialCode == code) {
          return true;
        }
      }
    },
    disableMaterialCheckBefore(checkedLists) {
      for (const code of checkedLists) {
        this.addDisableCode(code);
      }
    },
    addDisableCode(code) {
      switch (code) {
        case '400':
          this.disableCodeList = [...this.disableCodeList, ...this.disableListOfCode400];
          break;
        case '100':
          this.disableCodeList = [...this.disableCodeList, ...this.disableListOfCode100];
          break;
        case '200':
          this.disableCodeList = [...this.disableCodeList, ...this.disableListOfCode200];
          break;
        case '300':
          this.disableCodeList = [...this.disableCodeList, ...this.disableListOfCode300];
          break;
        case '500':
          this.disableCodeList = [...this.disableCodeList, ...this.disableListOfCode500];
          break;
        case '600':
          this.disableCodeList = [...this.disableCodeList, ...this.disableListOfCode600];
          break;
        case '700':
          this.disableCodeList = [...this.disableCodeList, ...this.disableListOfCode700];
          break;
      }
    },
    setUnchangedDisableCode() {
      if (this.selectedValue.findIndex((code) => code == 'unchanged') == -1) {
        this.disableCodeList = ['100', '200', '300', '400', '500', '600', '700'];
        this.selectedValue = ['unchanged'];
      } else {
        this.disableCodeList = [];
      }
    },
  },
  mounted() {
    if (this.checkedLists[0]) {
      this.disableMaterialCheckBefore(this.checkedLists);
    }
  },
  computed: {
    isRequired() {
      return this.extraRules.includes('required');
    },
    rules() {
      return this.extraRules.split('|');
    },
    veeRules() {
      let rules = [this.baseRule].concat(this.rules);

      // re-order rule required to first
      rules = uniq(
        sortBy(rules, [
          function (o) {
            return o.indexOf('required') ? 1 : 0;
          },
        ])
      );

      return rules.join('|');
    },
    veeMode() {
      return 'aggressive';
    },
    selectedValue: {
      get() {
        this.$logger.debug('selectedValue#get', this.value);
        return this.value;
      },
      set(val) {
        this.$logger.debug('selectedValue#set', val);
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 5px;
}
.disabledText {
  color: rgba(112, 112, 112, 0.9);
}
</style>
